const formatValue = (val) => {
    if (val && typeof val === 'object' && val._isAMomentObject) {
        return val.format('DD/MM/YYYY');
    }
    return val;
};

const RecapGPTRow = ({ label, value }) => {
    if (value === undefined || value === null || value === '') return null;

    return (
        <p>
            <span className={'text-muted'}>{label} : </span>
            {formatValue(value)}
        </p>
    );
};

export default RecapGPTRow;
